import { render, staticRenderFns } from "./ThemeCategory.vue?vue&type=template&id=4fb00c78"
import script from "./ThemeCategory.vue?vue&type=script&lang=js"
export * from "./ThemeCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports